import React from 'react';
import Header from "../main-header/header";
import Footer from "../about/Footer";
import './blog.css';

const blogPosts = [
  {
    title: "Inside the Making of 'Echoes of Time'",
    excerpt: "Take a behind-the-scenes look into the making of our latest sci-fi thriller...",
    image: "images/right-image-black-big1.jpeg",
    link: "/blog/echoes-of-time"
  },
  {
    title: "VMAA Live: Rhythm Fest Highlights",
    excerpt: "Unforgettable performances, backstage moments, and the crowd’s electric energy.",
    image: "images/left-image1.jpeg",
    link: "images/blog/blog2.jpg"
    
  },
  {
    title: "The Evolution of Music Videos in 2024",
    excerpt: "Explore how storytelling in music videos has transformed in today’s digital age.",
    image: "images/right-big1.jpeg",
    link: "/blog/music-videos-2024"
  }
];

export default function Blog() {
  return (
    <div>
        <Header />
    <div className="blog-page">
      <header className="blog-header">
        <h1>VMAA Blog</h1>
        <p>Stories, updates & behind-the-scenes insights from our creative world.</p>
      </header>

      <section className="blog-grid">
        {blogPosts.map((post, index) => (
          <div className="blog-card" key={index}>
            <img src={post.image} alt={post.title} />
            <div className="blog-content">
              <h2>{post.title}</h2>
              <p>{post.excerpt}</p>
              <a href={post.link} className="read-more">Read More →</a>
            </div>
          </div>
        ))}
      </section>
    </div>
    <Footer/>
    </div>
  );
}
